import { useState } from "react";
import { useMfgItems, type MfgItemRow } from "@/lib/mfg-catalog";
import { Input } from "@/components/ui/input";

export function MfgItemPicker({ excludeId, onPick }: { excludeId: number; onPick: (item: MfgItemRow) => void }) {
  const [q, setQ] = useState("");
  const { data } = useMfgItems({ q, page: 1, pageSize: 20 });
  const rows = (data?.rows ?? []).filter((r) => r.mfgItemId !== excludeId);
  return (
    <div className="space-y-2">
      <Input placeholder="Search items…" value={q} onChange={(e) => setQ(e.target.value)} />
      <ul className="max-h-64 overflow-auto rounded-md border">
        {rows.map((r) => (
          <li key={r.mfgItemId}>
            <button type="button" className="flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-accent" onClick={() => onPick(r)}>
              <span>{r.name}</span><span className="text-xs text-muted-foreground">{r.itemTypeCode}</span>
            </button>
          </li>
        ))}
        {rows.length === 0 && <li className="px-3 py-2 text-sm text-muted-foreground">No matches.</li>}
      </ul>
    </div>
  );
}
